import {
    ADD_REFERRAL,
    UPDATE_REFERRAL,
    DELETE_REFERRAL,
    GET_REFERRALS,
    GET_REFERRAL,
    REFERRAL_ERROR,
} from "../../actions/types";

const initialState = {
    referrals: [],
    referral: null,
    loading: true,
    error: {},
};

export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ADD_REFERRAL:
            return {
                ...state,
                referrals: payload,
                loading: false,
            };
        case UPDATE_REFERRAL:
            return {
                ...state,
                referral: payload,
                loading: false,
            };
        case DELETE_REFERRAL:
            return {
                ...state,
                referrals: payload,
                loading: false,
            };
        case GET_REFERRAL:
            return {
                ...state,
                referral: payload,
                loading: false,
            };
        case GET_REFERRALS:
            return {
                ...state,
                referrals: payload,
                loading: false,
            };
        case REFERRAL_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            return state;
    }
}
